import React from "react";
import { useAppNavigation, useAppRouter } from "@/context";
import { ActivePage, Breadcrumb } from "@/types";
import { getItemTitle, matchPath, getItemPath } from "@/utils";

export function useActivePage(): ActivePage | null {
  const navigationContext = useAppNavigation();
  const { pathname } = useAppRouter();
  const activeItem = matchPath(navigationContext, pathname);

  const rootItem = matchPath(navigationContext, "/");

  return React.useMemo(() => {
    if (!activeItem) {
      return null;
    }

    const breadcrumbs: Breadcrumb[] = [];

    if (rootItem) {
      breadcrumbs.push({
        title: getItemTitle(rootItem),
        path: "/",
      });
    }

    const segments = pathname.split("/").filter(Boolean);
    let prefix = "";
    for (const segment of segments) {
      const path = `${prefix}/${segment}`;
      prefix = path;
      const item = matchPath(navigationContext, path);
      if (!item) {
        continue;
      }
      const itemPath = getItemPath(navigationContext, item);
      const lastCrumb = breadcrumbs[breadcrumbs.length - 1];
      if (lastCrumb?.path !== itemPath) {
        breadcrumbs.push({
          title: getItemTitle(item),
          path: itemPath,
        });
      }
    }

    return {
      title: getItemTitle(activeItem),
      path: getItemPath(navigationContext, activeItem),
      breadcrumbs,
    };
  }, [activeItem, rootItem, pathname, navigationContext]);
}
